export default __webpack_public_path__ + "static/media/background.4d0a27f3.jpg";